module.exports = __webpack_public_path__ + "CN.png?0310e291e7caba24f8b506ae60061453";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/CN.png
// module id = 341
// module chunks = 0